import fecha from "fecha"

export function format(dateString, showYear = true)
{
    try{
        const fechaDate = fecha.parse(dateString, "YYYY-MM-DD");
        const fechaDateYear = fecha.format(fechaDate, "YYYY");
        const currentYear = fecha.format(new Date(), "YYYY");
        if( fechaDateYear === currentYear )
            return fecha.format(fechaDate, 'D MMM');
        return showYear ? fecha.format(fechaDate, 'D MMM YYYY') : fecha.format(fechaDate, 'D MMM');
    }
    catch (err)
    {
        return dateString
    }
}



// WEBPACK FOOTER //
// ./src/utils/date.js